import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'faq-list',
};

const FaqApi = createApi({
  reducerPath: 'faq-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getFaq: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.faq.list, body),
    }),
    createFaq: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.faq.create,
        method: 'post',
        body: body,
      }),
    }),
    editFaq: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.faq.update,
        method: 'post',
        body: body,
      }),
    }),
    deleteFaq: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.faq.update,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetFaqQuery, useCreateFaqMutation, useEditFaqMutation, useDeleteFaqMutation } = FaqApi;
export { FaqApi };
